import { render, staticRenderFns } from "./prorated-charge.vue?vue&type=template&id=67ecdcbd"
import script from "./prorated-charge.vue?vue&type=script&lang=js"
export * from "./prorated-charge.vue?vue&type=script&lang=js"
import style0 from "./prorated-charge.vue?vue&type=style&index=0&id=67ecdcbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports